<template>
    <form>
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Deduplication</h5>
                <button type="button" class="btn-close" @click="$emit('closeModal')"></button>
            </div>
            <div class="modal-body">
                <div class="container-fluid">
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import axios from 'axios';
//import { onMounted, ref } from "vue";
export default {
  name: 'ModalDedupe',
  props: {
    passedModalData: {
      type: String,
      default() {
        return 'Dataset'
      }
    }
  },
  data(){
    return{
        // test: []
    }
  },
  methods: {
    // methods
  },
  mounted() {
    // mounts
  }
}

</script>